import { WuiltContext } from "@wuilt/section-preview";
import React from "react";

const elementsContext = React.createContext<WuiltContext>({
  elements: {},
  base: {
    Image: React.forwardRef((props, ref) => (
      <img ref={ref as any} {...props} />
    )),
    Link: React.forwardRef((props, ref) => <a ref={ref as any} {...props} />),
    PageLink: React.forwardRef((props, ref) => (
      <a ref={ref as any} {...props} />
    )),
    Head: () => null,
    imageLoader: (props) => props.src,
    useRouter: () => {},
  },
  props: {},
  mode: "edit",
});

const { Provider, Consumer } = elementsContext;
export { Provider, Consumer };
export default elementsContext;
